// assets
import { IconSettings2 } from "@tabler/icons";
import interpret from '../json/interpret'
import patternsforyoursitepages from '../json/patternsforyoursitepages'
import rewriterulesforredirects from '../json/rewriterulesforredirects'
import createyourrobotstxtrules from '../json/createyourrobotstxtrules'
import structureddataforyourcontent from '../json/structureddataforyourcontent'

// constant
const icons = {
  IconSettings2,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const supplyChain = {
  id: "technicalOptimization",
  title: "Technical optimization",
  caption: "Technical optimization",
  type: "group",
  children: [
    {
      id: "technicalOptimization",
      title: "Technical optimization",
      type: "collapse",
      icon: icons.IconSettings2,

      children: [
        {
          id: "patterns-for-your-site-pages",
          title: "Generate Hreflang tags for to use as patterns for your site pages",
          titleType: "collapse",
          type: "item",
          url: "/patterns-for-your-site-pages",
          target: false,
          breadcrumbs: true,
          endPoint:"ai/hreflangtags",
          jsonobject:patternsforyoursitepages,
          editorTitile: "These href tags can be used as a pattern.",
          mainTitile: "Generate Hreflang tags for to use as patterns for your site pages",
          mainDescription:
            "Generate the hreflang tags to feature in pages targeted to the <country> in <language>",
        },
        {
          id: "rewrite-rules-for-redirects",
          title: "Generate .htaccess rewrite rules for redirects",
          titleType: "collapse",
          type: "item",
          url: "/rewrite-rules-for-redirects",
          target: false,
          breadcrumbs: true,
          endPoint:"ai/htaccess",
          jsonobject:rewriterulesforredirects,
          editorTitile: "The.htaccess rewrite rules for redirects are listed below.",
          mainTitile: "Generate .htaccess rewrite rules for redirects",
          mainDescription:
            "Generate the .htaccess rewrite rules to 301-redirect <source location> to <location destination>",
        },
        {
            id: "create-your-robots-txt-rules",
            title: "Generate the rules for your robots.txt",
            titleType: "collapse",
            type: "item",
            url: "/create-your-robots-txt-rules",
            target: false,
            breadcrumbs: true,
            endPoint:"ai/robottxt",
            jsonobject:createyourrobotstxtrules,
            editorTitile: "Semantic relevance of a text or a word",
          mainTitile: "Generate the rules for your robots.txt",
          mainDescription:
            "Generate a robots.txt rules to block the crawl <location to block> but allow the crawling of <location to crawl> within the domain",
          },
          {
            id: "structured-data-for-your-content",
            title: "Generate Structured Data for your content",
            titleType: "collapse",
            type: "item",
            url: "/structured-data-for-your-content",
            target: false,
            breadcrumbs: true,
            endPoint:"ai/structuredData",
            jsonobject:structureddataforyourcontent,
            editorTitile: "Here is the content's structured data.",
          mainTitile: "Generate Structured Data for your content",
          mainDescription:
            "Generate the FAQPage Schema markup for the following questions and answers",
          },
      ],
    },
  ],
};

export default supplyChain;
